export default "__VITE_ASSET__BedDpXSS__"